import React from "react";
import abb from '../images/clients/abb.png';
import apc from '../images/clients/apc.png';
import axora from '../images/clients/axora.png';
import coldair from '../images/clients/coldair.png';
import ge from '../images/clients/ge.png';
import gm from '../images/clients/gm.png';
import gmr from '../images/clients/gmr.png';
import isro from '../images/clients/isro.png';
import ntpc from '../images/clients/ntpc.png';
import parrys from '../images/clients/parrys.png';
import radisson from '../images/clients/radisson.png';
import sail from '../images/clients/sail.png';
import schneider from '../images/clients/schneider.png';
import sumadhura from '../images/clients/sumadhura.png';

const Clients = () => (
    <div className='transparent-card-wrapper full-width'>
        <div className='transparent-card center-card'>
            <h3 style={{ color: "#e47931" }}>Our Esteemed Clients</h3>
            <h1>Trusted by Industry Leaders</h1>
            <p>We take pride in our partnerships with some of the most respected names in the industry. Our commitment to quality and excellence has earned us the trust of these esteemed clients.</p>
        </div>
        <div className='transparent-card center-card'>
            <div className="client-grid">
                <div className="client-card"><img src={abb} alt="abb" /></div>
                <div className="client-card"><img src={apc} alt="apc" /></div>
                <div className="client-card"><img src={axora} alt="axora" /></div>
                <div className="client-card"><img src={coldair} alt="coldair" /></div>
                <div className="client-card"><img src={ge} alt="ge" /></div>
                <div className="client-card"><img src={gm} alt="gm" /></div>
                <div className="client-card"><img src={gmr} alt="gmr" /></div>
                <div className="client-card"><img src={isro} alt="isro" /></div>
                <div className="client-card"><img src={ntpc} alt="ntpc" /></div>
                <div className="client-card"><img src={parrys} alt="parrys" /></div>
                <div className="client-card"><img src={radisson} alt="radisson" /></div>
                <div className="client-card"><img src={sail} alt="sail" /></div>
                <div className="client-card"><img src={schneider} alt="schneider" /></div>
                <div className="client-card"><img src={sumadhura} alt="sumadhura" /></div>
            </div>
        </div>
    </div>
);
export default Clients;